import React, { useRef, useEffect } from 'react';
import FlightLineLayer from './FlightLineLayer';
import { useUpdateEffect } from 'ahooks';
import { registerEventLayer } from '../events';
import useProps from '../_util/useProps';

export default function(props) {
    const {
        data,
        features,
        url,
        params,
        zIndex,
        id: key,
        _key,
        name,
        style,
        labelField,
        template,
        show = true,
        groupLayer,
        legend,
        height,
        color,
        speed,
        width,
        flyWidth,
        layerControl = true,
        number,
        glowPower,
        heightProportion,
        lineWidth,
        ...otherProps
    } = props;
    const layerRef = useRef();
    const { map } = useProps();

    useEffect(() => {
        let layer = new FlightLineLayer({
            data,
            features,
            url,
            params,
            style,
            zIndex,
            key: key || _key,
            name,
            labelField,
            template,
            show,
            legend,
            height,
            color,
            speed,
            map,
            groupLayer,
            width,
            flyWidth,
            layerControl,
            number,
            glowPower,
            heightProportion,
            lineWidth,
            ...otherProps,
        });

        // 注册事件
        registerEventLayer(layer, props);

        layerRef.current = layer;
        return () => {
            layerRef.current.destroy();
        };
    }, []);

    useUpdateEffect(() => {
        layerRef.current.loadData(data);
    }, [JSON.stringify(data)]);

    useUpdateEffect(() => {
        layerRef.current.show = show;
    }, [show]);

    return <></>;
}
